<template>
	<b-field :label="$t('NotificationStrategy')">
		<b-select
			:placeholder="$t('ChooseNotificationStrategy')"
			v-model="selectedStrategy"
			expanded
			:disabled="canEdit === false"
			data-test-id="notificationStrategy"
		>
			<option
				v-for="strategy in strategiesList"
				:key="strategy.id"
				:value="strategy.id"
			>
				{{ `${$t(strategy.name)}` }}
			</option>
		</b-select>
	</b-field>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'
import { useAppStore } from '@/stores/app'

interface NotificationStrategy {
	name: string
	id: number
}

interface Props {
	modelValue?: number
	canEdit?: boolean
}

interface Emits {
	(e: 'update:modelValue', value: number): void
}

const props = withDefaults(defineProps<Props>(), {
	modelValue: 2,
	canEdit: true
})

const emit = defineEmits<Emits>()

const appStore = useAppStore()

const selectedStrategy = ref<number>(props.modelValue || 2)

const strategiesList = computed((): NotificationStrategy[] => {
	return appStore.getStrategies || []
})

onMounted(() => {
	if (props.modelValue) {
		selectedStrategy.value = props.modelValue
	}
})

watch(
	() => selectedStrategy.value,
	(newValue) => {
		emit('update:modelValue', newValue)
	},
	{ immediate: true }
)

watch(
	() => props.modelValue,
	(newValue) => {
		if (newValue !== undefined && newValue !== selectedStrategy.value) {
			selectedStrategy.value = newValue
		}
	}
)
</script>
